import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'; // Or use @highcharts/react components
import 'highcharts/modules/exporting';

interface ChartProps {
  title: string;
  id: number;
  height: number;
}

const Diversity: React.FC<ChartProps> = ({ title, id, height }) => {
  const [customerDiversity, setCustomerDiversity] = React.useState([]);

  const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
  React.useEffect(() => {
    fetch(`/dashboard/customer-diversity/${id}/?entity_id=${localStorage.getItem('entity_id')}`)
      .then(response => response.json())
      .then(data => 
        setTimeout(() => {
          setCustomerDiversity(data.customer_diversity);
        }, 100)
      );

    const handleResize = () => {
      if (chartComponentRef.current && chartComponentRef.current.chart) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const options: Highcharts.Options = {
        chart: {
            type: 'column'
        },
        title: {
            text: title,
            align: 'left'
        },
        
        xAxis: {
            type: 'category',
            title: {
                text: 'Products',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
        },

        yAxis: {
            min: 0,
            title: {
                text: 'Number of Products',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            labels: {
                formatter: function(this: Highcharts.AxisLabelsFormatterContextObject) {
                const v = this.value as number;
                const absv = Math.abs(v);
                if (absv >= 1000000) return v / 1000000 + 'M';
                if (absv >= 1000) return v / 1000 + 'K';
                    return String(v);
                },
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },

        tooltip: {
            valueSuffix: ''
        },

        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            },
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: function() {
                            console.log(this.category);
                        }
                    }
                }
            }
        },
        series: [
            {
                name: 'Number of Products',
                type: 'column',
                data: Object.entries(customerDiversity).map(([key, value]) => ({
                    name: value.name,
                    y: value.y
                }))
            }
        ],
    };

    return (
        <div style={{ height: height, width: '100%' }}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                allowChartUpdate={true}
                exportEnabled={true}
                ref={chartComponentRef}
                containerProps={{ style: { width: '100%', height: '100%', borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
            />
        </div>
    );
};

export default Diversity;
